import { createAsyncThunk } from '@reduxjs/toolkit'
import { notificationManagementAPI } from '@services/api'

export const fetchNotificationList = createAsyncThunk(
  'notificationManagement/fetchList',
  async (params: TNotificationManagementAPI.Params.FetchList, { rejectWithValue }) => {
    try {
      const response = await notificationManagementAPI.fetchList(params)
      return response.data
    } catch (error: any) {
      return rejectWithValue(error.response.data)
    }
  }
)

export const fetchSingle = createAsyncThunk(
  'notificationManagement/fetchSingle',
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await notificationManagementAPI.fetchSingle(id)
      return response.data
    } catch (error: any) {
      return rejectWithValue(error.response.data)
    }
  }
)

export const publishNotification = createAsyncThunk(
  'notificationManagement/publishNotification',
  async (data: TNotificationManagement.TState['notificationDetail']['data'], { rejectWithValue }) => {
    try {
      const response = await notificationManagementAPI.publishNotification(data)
      return response.data
    } catch (error: any) {
      return rejectWithValue(error.response.data)
    }
  }
)

export const updateNotification = createAsyncThunk(
  'notificationManagement/updateNotification',
  async (data: TNotificationManagement.TState['notificationDetail']['data'], { rejectWithValue }) => {
    try {
      const response = await notificationManagementAPI.updateNotification(data)
      return response.data
    } catch (error: any) {
      return rejectWithValue(error.response.data)
    }
  }
)
